import axios from 'axios';
import { message } from 'ant-design-vue';

// 是否 token 无效
let flagInvalidToken = false

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const showMessage = (msg) => {
    message.error(msg);
};

const errorHandle = (status, msg = '未知错误', code) => {
    console.log('errorHandle status:', status)
    let key = msg
    if (msg.includes('invalid token')) {
        console.log('flagInvalidToken:', flagInvalidToken)
        if (!flagInvalidToken) {
            flagInvalidToken = true
            setTimeout(() => { flagInvalidToken = false }, 1000)

            showMessage('无效的身份凭证，请重新登录');
            window.location.href = process.env.BASE_URL + '#/login'
            // source.cancel();
        }
        return
    }
    if (msg.includes('timeout')) {
        key = 'timeout'
        message.error({content: '请求超时', key });
        return
    }
    if (msg === 'http response status is not 200, status code = 400') {
        key = 'http response status error'
        message.error({content: msg, key });
        return
    }

    switch (code) {
        case 5000: // 删除片区时存在卡片
        case 303: // 充值模版被绑定
        case 304: // 计费模版被绑定
        case 305: // 分账模版被绑定
            break;
        case 1100: // 南平农商行错误提示   后端返回的message是个字符串
            /**
             * code: 1100,
             * message: "{"RespCode":"30310000300","RespMessage":"sub_appid和sub_openid不匹配"}"
            */
            try {
                let messageInfo = JSON.parse(msg);
                const { RespCode, RespMessage } = messageInfo || {};
                if (RespCode === '30310000014') {
                    showMessage('退款失败，订单只能线上退款1次，继续退还剩余金额，请线下处理!');
                } else {
                    showMessage(RespMessage);
                }
            } catch (err) {
                showMessage(msg);
            }
            break;
        default:
            showMessage(msg);
            break;
    }
};

const repuest = axios.create({ timeout: 1000 * 15 });

repuest.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

repuest.interceptors.request.use(
    (config) => {
        config.cancelToken = source.token
        return config
    },
    (error) => Promise.error(error)
);

repuest.interceptors.response.use(
    res => {
        // console.log('ResponseResult:', res)
        if (res.status === 200) {
            if (res.data.code === 0) {
                return res.data.data;
            } else {
                if (res.data.code === 5001) {
                    return Promise.reject(res);
                }
                errorHandle(res.data.code, res.data.message, res.data.code);
                return Promise.reject(res);
            }
        } else {
            Promise.reject(res);
        }
    },
    (error) => {
        console.log('ResponseCatch:', error)
        const { response } = error;

        // 主动取消
        if (axios.isCancel(error)) {
            return Promise.reject(response);
        }

        if (response) {
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        } else {
            errorHandle('other', error.toString());
            if (window.navigator.onLine) {
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        }
    }
);

export default repuest;
